export default class GoogleMapsHelper {
    public static mapInstance: any = null;
    public static autocompleteService: any = null;
    public static geocoder: any = null;
    public static mapMarkers: any[] = [];
    public static markerClusterer: any = null;
    public static infoWindows: any[] = [];
    public static activeInfoWindowId: any = null;

    static loader = new (<any>window).Loader({
        apiKey: (<any>document.getElementById("GoogleMapsAPIKey"))?.value,
        version: "weekly",
        libraries: ["core", "maps", "marker", "places"]
    });

    static mapOptions = {
        center: { lat: 45.68703497980636, lng: 9.59769021348251 },
        zoom: 14,
        minZoom: 12,
        maxZoom: 16,
        mapId: "1cfbb4b05b8356c5",
        disableDefaultUI: false,
        clickableIcons: false,
        zoomControl: false,
        zoomControlOptions: {
            position: 0
        },
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    }

    static async loadMap(isZoomControlEnable: boolean = true) {
        const self = this;

        navigator?.permissions?.query({ name: "geolocation" }).then((permissionStatus) => {
            permissionStatus.onchange = () => {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        const { latitude, longitude } = position.coords;
                        self.setCenter(latitude, longitude);
                        self.mapInstance.setZoom(16);
                    }
                );
            };
        });

        navigator?.geolocation?.getCurrentPosition(
            position => {
                const { latitude, longitude } = position.coords;
                this.mapOptions.center = { lat: latitude, lng: longitude }
            }
        );

        await this.loader.importLibrary("maps").then(async ({ Map }) => {
            if (isZoomControlEnable) {
                self.mapOptions.zoomControl = true;
                self.mapOptions.zoomControlOptions.position = google.maps.ControlPosition.TOP_RIGHT;
            }
            self.mapInstance = new Map(document.getElementById("GoogleMap") as HTMLElement, self.mapOptions);
        });
    }

    static getBounds() {
        return this.mapInstance.getBounds();
    }

    static setCenter(lat: number, lng: number) {
        this.mapInstance.setCenter(new google.maps.LatLng(lat, lng));
    }

    static addMarker(id: string, lat: number, lng: number, type: string, title: string, infowindowContent: string, isAppMobile: boolean = false) {
        const self = this;

        const markerDealer = document.createElement("img");
        markerDealer.src = !isAppMobile ? "/images/marker-dealer.svg" : "/areas/mobileapp/images/marker-app-dealer.svg";

        const markerExpert = document.createElement("img");
        markerExpert.src = !isAppMobile ? "/images/marker-expert.svg" : "/areas/mobileapp/images/marker-app-brembo-expert.svg";

        const markerGarage = document.createElement("img");
        markerGarage.src = !isAppMobile ? "/images/marker-garage.svg" : "/areas/mobileapp/images/marker-app-garage.svg";

        const markerUpgradeDealer = document.createElement("img");
        markerUpgradeDealer.src = !isAppMobile ? "/images/marker-upgrade-dealer.svg" : "/areas/mobileapp/images/marker-app-dealer-upgrade.svg";

        const markerUpgradeGarage = document.createElement("img");
        markerUpgradeGarage.src = !isAppMobile ? "/images/marker-upgrade-garage.svg" : "/areas/mobileapp/images/marker-app-garage-upgrade.svg";

        let content: any = null;

        switch (type) {
            case "Dealer":
            case "Official Partner":
                content = markerDealer;
                break;
            case "Garage":
                content = markerGarage;
                break;
            case "Brembo Expert":
            case "Expert Dealer":
                content = markerExpert;
                break;
            case "Upgrade Dealer":
                content = markerUpgradeDealer;
                break;
            case "Upgrade Installer":
            case "Racing Installer":
                content = markerUpgradeGarage;
                break;
        }

        const infowindow = new google.maps.InfoWindow({
            content: infowindowContent,
            ariaLabel: title,
            disableAutoPan: true
        });

        infowindow.set("id", id);

        infowindow.addListener("closeclick", () => {
            this.activeInfoWindowId = null;
            (<any>window).App.instances.vm.$store.commit("googleMapsStore/setActiveInfoWindowId", null);
        });

        this.infoWindows.push(infowindow);

        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.mapInstance,
            position: { lat: lat, lng: lng },
            content: content,
            title: title,
            collisionBehavior: google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL
        });

        marker.id = id;

        marker.addListener("click", () => {
            for (const item of this.infoWindows) {
                item.close();
            }

            this.activeInfoWindowId = id;

            (<any>window).App.instances.vm.$store.commit("googleMapsStore/setActiveInfoWindowId", this.activeInfoWindowId);

            infowindow.open({
                anchor: marker,
                map: self.mapInstance,
                shouldFocus: true
            });

            this.setCenter(lat, lng);
        });

        this.mapMarkers.push(marker);

        if (this.activeInfoWindowId == id) {
            infowindow.open({
                anchor: marker,
                map: self.mapInstance,
                shouldFocus: true
            });

            (<any>window).App.instances.vm.$store.commit("googleMapsStore/setActiveInfoWindowId", this.activeInfoWindowId);
        }
    }

    static clickMarker(markerId: string) {
        let marker = this.mapMarkers.find(x => x.id === markerId);
        if (marker) {
            let infowindow = this.infoWindows.find(x => x.id === markerId);

            for (const item of this.infoWindows) {
                this.activeInfoWindowId == null;
                item.close();
            }

            infowindow.open({
                anchor: marker,
                map: this.mapInstance,
                shouldFocus: true
            });

            this.activeInfoWindowId = markerId;
            (<any>window).App.instances.vm.$store.commit("googleMapsStore/setActiveInfoWindowId", this.activeInfoWindowId);
        }
    }

    static setMarkerCluster(isAppMobile: boolean = false) {
        const self = this;
        if (this.markerClusterer) {
            this.markerClusterer.setMap(null);
        }

        let renderer = {
            render({ count, position }, stats) {
                const icon = document.createElement('div');
                icon.innerHTML = '<div class="cluster">' + count + '</div>';

                const faPin = new google.maps.marker.PinElement({
                    glyph: icon,
                    glyphColor: 'rgba(255,255,255,0)',
                    background: 'rgba(255,255,255,0)',
                    borderColor: 'rgba(255,255,255,0)'
                });

                return new google.maps.marker.AdvancedMarkerElement({
                    map: self.mapInstance,
                    position,
                    content: faPin.element,
                    title: String(count)
                });
            }
        }

        this.markerClusterer = new (<any>window).MarkerClusterer({ markers: this.mapMarkers, map: this.mapInstance, renderer: renderer });
    }

    static removeMarkers() {
        for (const item of this.infoWindows) {
            item.close();
        }

        this.infoWindows = [];

        for (let i = 0; i < this.mapMarkers.length; i++) {
            this.mapMarkers[i].setMap(null);
        }

        this.mapMarkers = [];

        (<any>window).App.instances.vm.$store.commit("googleMapsStore/setActiveInfoWindowId", null);
    }

    static closeInfoWindows() {
        for (const item of this.infoWindows) {
            item.close();
        }

        this.activeInfoWindowId = null;
        (<any>window).App.instances.vm.$store.commit("googleMapsStore/setActiveInfoWindowId", null);
    }

    static setActiveInfoWindowId(id: string) {
        if (this.activeInfoWindowId !== null) {
            for (const item of this.infoWindows) {
                item.close();
            }
        }

        this.activeInfoWindowId = id;
        (<any>window).App.instances.vm.$store.commit("googleMapsStore/setActiveInfoWindowId", this.activeInfoWindowId);
    }

    static getAutocompleteService() {
        if (!this.autocompleteService) {
            this.autocompleteService = new google.maps.places.AutocompleteService();
        }
        return this.autocompleteService;
    }

    static getGeocoder() {
        if (!this.geocoder) {
            this.geocoder = new google.maps.Geocoder();
        }
        return this.geocoder;
    }
}